import {
  Avatar,
  IconButton,
  Popover,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import * as React from "react";
import { useState } from "react";
import styles from "./MenuFooter.module.scss";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import LogoutIcon from "@mui/icons-material/Logout";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { useSelector } from "react-redux";
import { selectHeiUser } from "../../../Auth/store/accountSlice";
import { useMsal } from "@azure/msal-react";
import { logoutUser } from "../../../Auth/utils/jwtUtils";
import { useNavigate } from "react-router-dom";
import routes from "../../../Common/consts/routes";
import { getUserJiraProfile } from "../../../Profile/api/profileClient";

interface IMenuFooterProps {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

const MenuFooter: React.FunctionComponent<IMenuFooterProps> = ({
  collapsed,
  setCollapsed,
}) => {
  const heiUser = useSelector(selectHeiUser);
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [hasJiraAccess, setHasJiraAccess] = useState<boolean | null>(null);

  const handleAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    if (hasJiraAccess === null) {
      getUserJiraProfile()
        .then((data) => setHasJiraAccess(data.hasJiraOrConfluenceAccess))
        .catch(() => setHasJiraAccess(false));
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    setAnchorEl(null);
    await logoutUser(instance);
  };

  const handleEditProfile = () => {
    setAnchorEl(null);
    navigate(routes.editProfile);
  };

  const open = Boolean(anchorEl);

  return (
    <div className={styles.footerWrapper}>
      <Avatar onClick={handleAvatarClick} sx={{ cursor: "pointer" }}>
        {heiUser.initials}
      </Avatar>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <List sx={{ minWidth: 200, padding: 1 }}>
          <ListItem disablePadding>
            <Typography
              variant="subtitle2"
              sx={{ padding: "8px 16px", fontWeight: "bold" }}
            >
              {heiUser.name || heiUser.email}
            </Typography>
          </ListItem>
          {hasJiraAccess &&
            (heiUser.email.endsWith("@heiway.net") ||
              heiUser.adPrinciple.toLowerCase().endsWith("@heiway.net")) && (
              <ListItem disablePadding>
                <ListItemButton onClick={handleEditProfile}>
                  <ManageAccountsIcon sx={{ marginRight: 1 }} />
                  <ListItemText primary="Edit profile" />
                </ListItemButton>
              </ListItem>
            )}
          <ListItem disablePadding>
            <ListItemButton onClick={handleLogout}>
              <LogoutIcon sx={{ marginRight: 1 }} />
              <ListItemText primary="Log out" />
            </ListItemButton>
          </ListItem>
        </List>
      </Popover>
      <IconButton onClick={() => setCollapsed(!collapsed)}>
        {collapsed && <KeyboardDoubleArrowRightIcon />}
        {!collapsed && <KeyboardDoubleArrowLeftIcon />}
      </IconButton>
    </div>
  );
};

export default MenuFooter;
